import React from 'react';
import { format, isSameYear, type Locale } from 'date-fns';
import Text from '@ingka/text';
import { getLocale } from '../../../helpers/localeHelper';

interface AdjacentWeeksRangeProps {
  start: string;
  end: string;
}

const getDateString = (
  start: string,
  end: string,
  locale: Locale | undefined,
  shortDateFormat: string,
  longDateFormat: string,
): string =>
  `${format(start, isSameYear(start, end) ? shortDateFormat : longDateFormat, {
    locale,
  })} - ${format(end, longDateFormat, { locale })}`;

const { dateAndTime } = CSS_CONFIG.formats;
const { date: shortDate, longDate } = dateAndTime;
const SHORT_DATE_FORMAT = shortDate || 'dd MMM';
const LONG_DATE_FORMAT = longDate || 'dd MMM yyyy';

const AdjacentWeeksRange: React.FC<AdjacentWeeksRangeProps> = ({
  start,
  end,
}) => {
  const locale = getLocale();
  return (
    <Text tagName="p" textStyle="Body.L" data-cy="ts-picker-title">
      {getDateString(start, end, locale, SHORT_DATE_FORMAT, LONG_DATE_FORMAT)}
    </Text>
  );
};

export default AdjacentWeeksRange;
